import PageSection from "@components/PageSection";
import React from "react";
import { ContentItem } from "@typed/content";
import { Link } from "@components/Catalyst/link";

interface IProps {
  techSheetList: ContentItem[];
}
const AdditionalLinks = ({ techSheetList }: IProps) => (
  <PageSection sectionName="Additional Links">
    {/* 
  <DescriptionList  >
            
      {techSheetList.map(({ id, title, type, description, slug }) => {
          const contentType = iconMapping[type ?? ""] ??  iconMapping["reference-material"];
        
        return(
          <>
            <DescriptionTerm key={`${id}-Key`}>
            <Link className="underline" href={slug}>
            <div className="flex gap-1">
              <img src={contentType.image} width={20} height={20} alt={contentType.name} />
                {title}
                </div>
            </Link>
            </DescriptionTerm>
            <DescriptionDetails key={`${id}-Detail`}>{description}</DescriptionDetails>
        </>
       
      );}
    )}
           </DescriptionList> */}
    <ul className="list-inside list-disc pb-2 pl-2 marker:text-slate-500">
      {techSheetList.map(({ title, slug }) => (
        <li key={slug}>
          <Link className="underline" href={slug}>
            {title}
          </Link>
        </li>
      ))}
    </ul>
  </PageSection>
);

export default AdditionalLinks;
